import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { IPollOption } from 'models/polls/polloptions';
import { submitVotePoll } from 'modules/polls/managepoll';
import { IManagePollAction } from 'models/polls/managepoll';
import { cookies } from 'helpers/cookies';
require('./style.css');

export interface IProps {
	sectionItem: IPortalPageSectionItem;
	submitVotePoll?: Redux.ActionCreator<IManagePollAction>;
	isLastItemInRow?: boolean;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		state,
	}),
	(dispatch) => ({
		submitVotePoll: (pollId: string, pollOption: IPollOption) => dispatch(submitVotePoll(pollId, pollOption)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewSectionItemPoll extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onPollOptionChange = this.onPollOptionChange.bind(this);
	}

	private onPollOptionChange(pollOption: IPollOption) {
		const pollId: string = (this.props.sectionItem.elements[2] as ISectionTextElement).text;
		this.props.submitVotePoll(pollId, pollOption);
	}

	public render() {
		const { t } = this.props;
		const { elements } = this.props.sectionItem;

		const pollId: string = (this.props.sectionItem.elements[2] as ISectionTextElement).text;

		let pollOptions: IPollOption[] = [];
		const pollOptionsElement = elements[4] as ISectionTextElement;
		if (pollOptionsElement && pollOptionsElement.text && pollOptionsElement.text.length > 0) {
			pollOptions = JSON.parse(pollOptionsElement.text);
		}

		let alreadyVoted: boolean = false;
		if (cookies.get('POLL_' + pollId)) {
			alreadyVoted = true;
		}

		let content: JSX.Element = null;
		if (!alreadyVoted) {
			const pollOptionsArray = pollOptions
				.sort((a, b) => a.sortOrder - b.sortOrder)
				.map((pollOption: IPollOption, index: number) => {
					let optionContent: JSX.Element = null;
					switch (pollOption.sortOrder) {
						case 0:
							optionContent = (
								<button key={index} className="reaction md">
									<img src={require('containers/Html/icons/polls/poll-sad-sm.svg')} className="icon normal" />
									<img
										src={require('containers/Html/icons/polls/poll-sad-lg.svg')}
										className="icon hovered"
										onClick={() => {
											this.onPollOptionChange(pollOption);
										}}
									/>
								</button>
							);
							break;

						case 1:
							optionContent = (
								<button key={index} className="reaction lo">
									<img src={require('containers/Html/icons/polls/poll-nothing-sm.svg')} className="icon normal" />
									<img
										src={require('containers/Html/icons/polls/poll-nothing-lg.svg')}
										className="icon hovered"
										onClick={() => {
											this.onPollOptionChange(pollOption);
										}}
									/>
								</button>
							);
							break;

						case 2:
							optionContent = (
								<button key={index} className="reaction hi">
									<img src={require('containers/Html/icons/polls/poll-happy-sm.svg')} className="icon normal" />
									<img
										src={require('containers/Html/icons/polls/poll-happy-lg.svg')}
										className="icon hovered"
										onClick={() => {
											this.onPollOptionChange(pollOption);
										}}
									/>
								</button>
							);
							break;

						case 3:
							optionContent = (
								<button key={index} className="reaction sh">
									<img src={require('containers/Html/icons/polls/poll-super-sm.svg')} className="icon normal" />
									<img
										src={require('containers/Html/icons/polls/poll-super-lg.svg')}
										className="icon hovered"
										onClick={() => {
											this.onPollOptionChange(pollOption);
										}}
									/>
								</button>
							);
							break;

						default:
							break;
					}

					return optionContent;
				});
			content = (
				<div className="unanswered">
					<div className="topIcon">
						<img src={require('containers/Html/icons/polls/poll-question_icon.svg')} className="icon" />
					</div>
					<h2 className="pollQuestion">{(elements[0] as ISectionTextElement).text}</h2>
					<p className="pollDescription">{(elements[3] as ISectionTextElement).text}</p>
					<div className="reactionHolder">{pollOptionsArray}</div>
				</div>
			);
		} else {
			content = (
				<div className="answered">
					<div className="topIcon">
						<img src={require('containers/Html/icons/polls/poll-question_icon.svg')} className="icon" />
					</div>
					<h2 className="pollQuestion">{t('PortalPage_Section_Type2_ThankYou_Label')}</h2>
					<p className="pollDescription">{t('PortalPage_Section_Type2_Answered_Text')}</p>
				</div>
			);
		}

		return (
			<div className="col-12 col-sm-6 col-md-6 col-xl-3 col-xlg-3 portalPagePollItem">
				<div className="itemHolder">
					<div className="pollHeader">{(elements[1] as ISectionTextElement).text}</div>
					<div className="pollContent">{content}</div>
				</div>
			</div>
		);
	}
}

export { ViewSectionItemPoll };
